module.exports = __webpack_public_path__ + "static/media/img_14.c41b83ef.JPG";